const PREFS_PREFIX = 'CG.PREFS.';

export enum Prefs {
  LAST_USED_ORG_ID = 'LAST_USED_ORG_ID',
  LAST_USED_LAYERS = 'LAST_USED_LAYERS',
  LAST_USED_METADATA_FIELDS = 'LAST_USED_METADATA_FIELDS',
  LAST_USED_BASEMAP = 'LAST_USED_BASEMAP',
  EXPANDED_SECTIONS = 'EXPANDED_SECTIONS',
  /** Device-local Layer Library picker expansion (node-id keyed JSON array). Distinct from the label-keyed legacy EXPANDED_SECTIONS. */
  EXPANDED_NODE_IDS = 'EXPANDED_NODE_IDS',
  PINNED_LAYER_IDS = 'PINNED_LAYER_IDS',
  PREFERRED_MAP_LAYERS = 'PREFERRED_MAP_LAYERS',
  /** Visible custom-data leaf ids for one project (suffix = projectId). Project-scoped because custom-data ids are. */
  CUSTOM_DATA_LAYERS = 'CUSTOM_DATA_LAYERS',
  LAST_VIEWED_MESSAGE_ID = 'LAST_VIEWED_MESSAGE_ID',
  LAST_VIEWED_ACTIVITY_ID = 'LAST_VIEWED_ACTIVITY_ID',
  ADVANCED_FILTER_STATE = 'ADVANCED_FILTER_STATE',
  PROJECT_LIST_SORT = 'PROJECT_LIST_SORT',
  PROJECT_LIST_FILTER = 'PROJECT_LIST_FILTER',
  CONFLICTS_SUMMARY_VIEW = 'CONFLICTS_SUMMARY_VIEW',
  /** Set once the user has acted on the "Reports have moved" notice (suffix = user id). */
  REPORTS_MOVED_SEEN = 'REPORTS_MOVED_SEEN',
}

let warnedRead = false;
let warnedWrite = false;

function prefKey(pref: Prefs, suffix?: string): string {
  return suffix ? `${PREFS_PREFIX}${pref}.${suffix}` : `${PREFS_PREFIX}${pref}`;
}

export function getPref(pref: Prefs, suffix?: string): string | null {
  try {
    // Naming localStorage can itself throw when a browser blocks storage.
    return localStorage.getItem(prefKey(pref, suffix));
  } catch (e) {
    if (!warnedRead) {
      warnedRead = true;
      console.warn('Preference read failed, browser storage is unavailable', e);
    }

    return null;
  }
}

export function setPref(pref: Prefs, value: string, suffix?: string): void {
  try {
    localStorage.setItem(prefKey(pref, suffix), value);
  } catch (e) {
    if (!warnedWrite) {
      warnedWrite = true;
      console.warn('Preference write failed, browser storage is unavailable', e);
    }
  }
}
